<template>
    <form method='post' :action="url" id="vue-form">
        <input name="cmd" type="hidden" value="_cart">
        <input name="upload" type="hidden" value="1">
        <input name="business" type="hidden" :value="business">
        <input name="shopping_url" type="hidden" value="">
        <input name="currency_code" type="hidden" value="EUR">
        <input name="return" type="hidden" :value="succes_url">
        <input type='hidden' name='cancel_return' :value="fail_url">
        <input name="rm" type="hidden" value="2">
        <template
            v-for="({id, title, quantity, price}, index) in items"
        >
            <input
                :key="`id-${id}`"
                :name="`item_number_${index+1}`"
                type="hidden"
                :value="id"
            >
            <input
                :key="`name-${id}`"
                :name="`item_name_${index+1}`"
                type="hidden"
                :value="title"
            >
            <input
                :key="`id-${id}`"
                :name="`amount_${index+1}`"
                type="hidden"
                :value="price * quantity"
            >
        </template>
    </form>
</template>

<script>
const paypalUrl = window.groovie.paypal_url;
const paypalBussines = window.groovie.paypal_bussines;
const succesUrl = window.groovie.succes_url;
const failUrl = window.groovie.fail_url;

export default {
    name: 'paypal',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            url: paypalUrl,
            business: paypalBussines,
            succes_url: succesUrl,
            fail_url: failUrl
        };
    }
};
</script>




// WEBPACK FOOTER //
// src/components/Paypal.vue